<template>
	<div class="pageArea">
		<Head2></Head2>
		<div class="mainArea">
			<div class="sortTitle">{{$t('pages.confirmOrder.breadcrumb')}}</div>
			<div class="steps">
				<div class="stepTextLeft">
					<img  src="../assets/images/1.png"/>
					<div >{{$t('pages.confirmOrder.steps.pick')}}</div>
				</div>
				<div class="stepTextMiddle">
					<img  src="../assets/images/2.png"/>
					<div >{{$t('pages.confirmOrder.steps.submit')}}</div>
				</div>
				<div class="stepTextRight">
					<img  src="../assets/images/3.png"/>
					<div >{{$t('pages.confirmOrder.steps.done')}}</div>
				</div>
			</div>
			<div class="cardArea">
				<div class="cardTitle">
					<div class="title">{{$t('pages.confirmOrder.address_title')}}</div>
					<div class="addressTitleBtn"  @click="showAddress(0)">{{$t('pages.confirmOrder.add_address_btn')}}</div>
				</div>
				<div class="addressAddArea" v-if="receiveInfo.length==0">
					<img  src="../assets/images/address.png" class="addressIcon"/>
					<div>{{$t('pages.confirmOrder.no_address',{add: $t('pages.confirmOrder.add')})}}<span class="addressBtn"  @click="showAddress(0)"></span></div>
				</div>
				<div  v-else>
				<div  v-for="(item,index) in receiveInfo" :key="item.id">
					<div class="addressli" v-if="index==0">
						<div class="userName" :class="{active: receiveId == item.id}" @click="receiveClick(item.id)">{{item.receive_man}}</div>
						<div class="addressInfo">
							<div class="addressLeft">
								<div class="addrTel">{{item.receive_mobile}}</div>
								<div>{{item.address}}</div>
							</div>
							<div class="addressTool" v-if="item.is_default==1">
								<div class="initBtn">{{$t('pages.confirmOrder.default')}}</div>
								<div @click="showAddress(item.id)">{{$t('pages.confirmOrder.edit')}}</div>
								<div class="delText" @click="DeleteContact(item.id)">{{$t('pages.confirmOrder.delete')}}</div>
							</div>
								<div class="addressTool" v-else>
										<div @click="SetDefault(item.id,item.member_id)">{{$t('pages.confirmOrder.set_default')}}</div>
										<div @click="showAddress(item.id)">{{$t('pages.confirmOrder.edit')}}</div>
										<div class="delText" @click="DeleteContact(item.id)">{{$t('pages.confirmOrder.delete')}}</div>
									</div>
						</div>
					</div>
					<div class="addressli" v-else-if="index>0&&moreAddress" >
						<div class="userName" :class="{active: receiveId == item.id}" @click="receiveClick(item.id)">{{item.receive_man}}</div>
						<div class="addressInfo">
							<div class="addressLeft">
								<div class="addrTel">{{item.receive_mobile}}</div>
								<div>{{item.address}}</div>
							</div>
							<div class="addressTool" v-if="item.is_default==1">
								<div class="initBtn">默认</div>
								<div @click="showAddress(item.id)">编辑</div>
								<div class="delText" @click="DeleteContact(item.id)">删除</div>
							</div>
							<div class="addressTool" v-else>
									<div @click="SetDefault(item.id,item.member_id)">设为默认收货地址</div>
									<div @click="showAddress(item.id)">编辑</div>
									<div class="delText" @click="DeleteContact(item.id)">删除</div>
							</div>
						</div>
					</div>
				</div>
					<div class="moreAddress" @click='moreClick'>{{$t('pages.confirmOrder.more_addresses',{count: contactcount-1})}}
					<img src="../assets/images/rightArrowGray.png" class="arrowTop" v-if="moreAddress"/>
					<img src="../assets/images/rightArrowGray.png" class="arrowBottom" v-else/>
				</div>
				</div>
			</div>
			<div class="cardArea">
				<div class="cardTitle">
					<div class="title">{{$t('pages.confirmOrder.invoice_title')}}</div>
				</div>
				<div>
						<div class="tabBtns">
							<div class="tabBtn invoiceBtn"  :class="{active: memberInfo.invoice_type == 1}"><div class="orange">专</div>{{$t('pages.confirmOrder.invoice_type_special')}}
							<img  src="../assets/images/gou.png" v-if="memberInfo.invoice_type ==1"/>
							</div>
							<div class="tabBtn invoiceBtn"  :class="{active: memberInfo.invoice_type == 2}"><div class="blue">普</div>{{$t('pages.confirmOrder.invoice_type_general')}}
							<img  src="../assets/images/gou.png"  v-if="memberInfo.invoice_type ==2"/>
							</div>
						</div>
					<div class="addInvoice"  @click="showPopup(0)"   v-if="memberInfo.invoice_head==''">
						{{$t('pages.confirmOrder.add_invoice')}}
					</div>
					<div class="invoiceDetail" v-else >
							<div class="invoiceEditBtn" @click="showPopup(memberInfo.id)">{{$t('pages.confirmOrder.edit')}}</div>
							<ul>
								<li>{{$t('pages.confirmOrder.invoice_head')}}{{memberInfo.invoice_head}}</li>
								<li>{{$t('pages.confirmOrder.invoice_taxno')}}{{memberInfo.invoice_taxno}}</li>
								<li>{{$t('pages.confirmOrder.invoice_register_address')}}{{memberInfo.invoice_register_address}}</li>
								<li>{{$t('pages.confirmOrder.invoice_register_mobile')}}{{memberInfo.invoice_register_mobile}}</li>
								<li>{{$t('pages.confirmOrder.invoice_branch')}}{{memberInfo.invoice_branch}}</li>
								<li>{{$t('pages.confirmOrder.invoice_accountno')}}{{memberInfo.invoice_accountno}}</li>
							</ul>
					</div>
				</div>
			</div>
			<div class="cardArea">
				<div class="cardTitle">
					<div class="title">{{$t('pages.confirmOrder.pay_method_title')}}</div>
				</div>
				<div class="payBtn">{{$t('pages.confirmOrder.online_pay')}}</div>
				<div class="payWay">
					{{$t('pages.confirmOrder.pay_support')}}
					<img src="../assets/images/wechartSmall.png" class="payIcon"/>{{$t('pages.confirmOrder.pay1')}}
					<img src="../assets/images/zhiSmall.png"  class="payIcon"/>{{$t('pages.confirmOrder.pay2')}}
					<img src="../assets/images/carSmall.png"  class="payIcon"/>{{$t('pages.confirmOrder.pay3')}}
				</div>
			</div>
			<div class="cardArea2" >
				<div class="cardTitle">
					<div class="listTitle">{{$t('pages.confirmOrder.product_list_title')}}</div>
					<div class="backCar" @click="ReturnShoppingCart()">{{$t('pages.confirmOrder.back_to_cart')}}</div>
				</div>
				<table>
					<thead>
						<th></th>
						<th>{{$t('pages.confirmOrder.th_item_info')}}</th>
						<th>{{$t('pages.confirmOrder.th_spec_param')}}</th>
						<th>{{$t('pages.confirmOrder.th_unit_price')}}</th>
						<th>{{$t('pages.confirmOrder.th_quantity')}}</th>
						<th>{{$t('pages.confirmOrder.th_subtotal')}}</th>
					</thead>
					<tbody>
						<tr v-for="(item,index) in payList" :key="item.skuId">
							<td class="infoDetail"><div class="tdInner">{{index+1}}</div></td>
							<td>
								<div class="tdInner tdFlex">
								<img  src="../assets/images/peoImg3.png"/>
								<div class="infoDetail">
									<div>{{item.product_name}}</div>
									<div class="grayText">{{item.cate_name}}</div>
								</div>
								</div>
							</td>
							<td>
								<div class="tdInner parameterInfo">{{item.sku_text}}</div>					
							</td>
							<td>
								<div class="tdInner">
									<div class="redText">￥{{item.sku_price+item.sku_tax}} (含税)</div>
									<div class="grayText">￥{{item.sku_price}} (未税)</div>
								</div>
								
							</td>
							<td class="infoDetail"><div class="tdInner">{{item.number}}</div></td>
							<td>
								<div class="tdInner">
									<div class="redText">￥{{item.total_price+item.total_tax}} (含税)</div>
									<div class="grayText">￥{{item.total_price}} (未税)</div>	
								</div>
							</td>
						</tr>
						
					</tbody>
				</table>
				
			</div>
		
			<div class="cardArea">
				<div class="cardTitle">
					<div class="title">{{$t('pages.confirmOrder.remarks_title')}}</div>
				</div>
				<div>
					
					<div class="layouArea">
						<div class="layoutTitle">{{$t('pages.confirmOrder.delivery_date_label')}}</div>
						<div class="tabBtns">
							<div class="tabBtn" :class="{active:dateType ==0}" @click="dateClick(0)">{{$t('pages.confirmOrder.delivery_option_all')}}
							<img  src="../assets/images/gou.png" v-if="dateType ==0"/>
							</div>
							<div class="tabBtn" :class="{active:dateType ==1}"  @click="dateClick(1)">{{$t('pages.confirmOrder.delivery_option_weekday')}}
							<img  src="../assets/images/gou.png"  v-if="dateType ==1"/>
							</div>
						</div>
					</div>
					<div class="layouArea">
						<div class="layoutTitle">{{$t('pages.confirmOrder.purchase_order_no_label')}}</div>
						<div>
							<input type="text" :placeholder="$t('pages.confirmOrder.purchase_order_placeholder')" class="inputText" id="saleNo" v-model="form.saleNo"/>
						</div>
					</div>
					<div class="layouArea">
						<div class="layoutTitle">备注：</div>
						<div>
							<input type="text" placeholder="请填写采购备注信息，建议跟客服事先确认" class="inputText"  id="memo"  v-model="form.memo"/>
						</div>
					</div>
					<div class="layouArea">
						<div class="layoutTitle">附件：</div>
						<div>
							<div  class="uploadImgs">
							<div v-for="(item,index) in images" :key="index">
								<img :src="item"/>
								<button @click="removeImage(index)">删除</button>
							</div>
							<div class="updateArea">
								<input type="file" ref="fileInput"  @change="handleUpdate()"/>
								<img src="../assets/images/update.png"  @click="uploadImage()"/>
							</div>
							</div>
							
							<div class="updateTip">（支持jpeg、jpg、png等图片格式，最多上传5个，每个大小小于5M）</div>
						</div>
					</div>
				</div>
			</div>
			
<!-- 			<div class="cardArea">
				<div class="cardTitle">
					<div class="listTitle">优惠券<img src="../assets/images/downArrow.png" class="downIcon"/></div>
				</div>
			</div> -->
			
			<div class="cardArea">
				<div class="settlement">
					<div class="settlementTitle">商品总数：</div>
					<div class="settlementVal">{{totalCount}}</div>
				</div>
				<div class="settlement">
					<div class="settlementTitle">商品含税总额：</div>
					<div class="settlementVal">￥{{totalAmount}}</div>
				</div>
				<div  class="settlement">
					<div class="settlementTitle">税额：</div>
					<div class="settlementVal">￥{{totalTax}}</div>
				</div>
<!-- 				<div  class="settlement">
					<div class="settlementTitle">优惠券抵用：</div>
					<div class="settlementVal">-￥100.00</div>
				</div> -->
				<div  class="settlement">
					<div class="settlementTitle">运费：</div>
					<div class="settlementVal">￥{{logistic}}</div>
				</div>
				<div class="settlementBtns">
					<div class="settlementText">应付含税总额：<span>￥{{totalPay}}</span></div>
					<div class="settlementBtn" :disabled="isSubmitting" @click="submitOrder()">提交订单</div>
				</div>
			</div>			
			
		</div>
		
		<Foot2></Foot2>
		<PopupInvoice :visible="popupVisible"  :selectId="editInvoiceId"  @close="closePopup"></PopupInvoice>
		
		<PopupAddress :visible="addressVisible" :selectId="editId" @close="closeAddress"></PopupAddress>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import PopupInvoice from '../components/popupInvoice.vue';
	import PopupAddress from '../components/addressPopup.vue'
	export default{
		components:{
			Head2,
			Foot2,
			PopupInvoice,
			PopupAddress
		},
		data(){
			return {
				invoice:0,
				dateType:0,
				idstr:"",
				payList:[],
				parameterList:[],
				totalCount:0,
				totalTax:0,
				logistic:0,
				totalAmount:0,		
				totalPay:0,
				images:[],
				selectedFile: null,
				receiveId:0,//选择的收货地址，暂时默认为2
				payWay:1,//支付方式，1微信，2支付包，3银联
				form: {
				    saleNo: '',
				    memo: '',
				},
				popupVisible: false,
				addressVisible: false,
				receiveInfo:[],
				editId:0,
				memberInfo:{},
				editInvoiceId:0,
				moreAddress: false,
				contactcount:0,
				isSubmitting: false, // 控制提交状态
			}
		},
		created() {
			this.GetProductInfo();
			this.getReceiveInfo();
			this.GetMemberInfo();
			console.log(this.receiveInfo.length==0)
		},
		methods:{
			GetProductInfo(){
				
				if(localStorage.getItem('payList') != "undefine"&&localStorage.getItem('payList') !="")
				{
					this.parameterList=JSON.parse(localStorage.getItem('payList'));
					this.parameterList.forEach(item => {
						this.idstr+=item.skuId+",";
					});
					this.$scUtil.axiosPut(this, 'ProductApi/GetPayProductList', {
						skuIds: this.idstr,
						userName: localStorage.getItem('username'),
					}, res => {
						if (res.code == 100) {
							res.data.forEach(item => {
							    item.number=this.parameterList.find(p=>p.skuId).number;
								item.total_price= parseFloat(item.sku_price*item.number);
								item.total_tax= parseFloat(item.sku_tax*item.number);
								this.totalCount+=item.number;
								this.totalTax=item.total_tax;
								this.totalAmount=item.total_price+item.total_tax;
								this.totalPay=this.totalAmount;
							});
							this.payList=res.data;
						}
				 
					});
				}
			},
			invoiceClick(idx){
				this.invoice = idx;
			},
			receiveClick(idx){
				this.receiveId = idx;
			},
			moreClick(){
				this.moreAddress = !this.moreAddress
			},
			dateClick(idx){
				this.dateType = idx;
			},
			uploadImage(){			
				this.$refs.fileInput.click();
			},
			handleUpdate(){
				 const file = this.$refs.fileInput.files[0];
				 
				 const validTypes = ['image/jpeg', 'image/png', 'image/gif','image/jpg'];
			 	
				const maxSize = 5 * 1024 * 1024; // 5 MB
								// 检查文件类型			
								if (!validTypes.includes(file.type)) {        
									this.$message({message: this.$t('pages.confirmOrder.image_type_error'),type: "warning"});            
									return;    
								}
								// 检查文件大小        
								if (file.size > maxSize) {            
									this.$message({message: this.$t('pages.confirmOrder.image_size_error'),type: "warning"});
									return;
								}
								if(this.images.length==5)
								{
										this.$message({message: this.$t('pages.confirmOrder.image_max_error',{max:5}),type: "warning"});
										return;
								}
				 console.log(file);
				 const formData = new FormData();	 
				 formData.append('fileList', file);		 
				this.$scUtil.axiosUpload(this, 'UploadApi/UploadFile?fileModule=17', formData, res => {				
					if (res.code == 100) {
						this.images.push(this.$scUtil.globalData.apiServer+res.data.filename)
					}
			 
				});
			},
			removeImage(i)
			{
				this.images.splice(i, 1);
			},
			submitOrder()
			{
				if (this.isSubmitting) {
                
				this.$message({
					message: this.$t('pages.confirmOrder.submitting'),
					type: "warning"
				});	
				return; // 如果正在提交，则不再执行
				}
				this.isSubmitting = true; // 设置状态为正在提交
				
				this.$scUtil.axiosPut(this, 'OrderApi/CreateOrder', {
					userName:localStorage.getItem('username'),
					receiveId:this.receiveId,
					detail:JSON.stringify(this.parameterList),
					memo:this.form.memo,
					saleNo:this.form.saleNo,
					memo_images:JSON.stringify(this.images),
					payWay:this.payWay,
					receive_type:this.dateType,
					cartIds:localStorage.getItem('cartIds')
				}, res => {
					console.log(JSON.stringify(res));
					if (res.code == 100) {
						this.isSubmitting = false;
						localStorage.setItem('cartIds',"");
						localStorage.setItem('payList',"");
						this.$router.push({ path:'/pay' , query:{id:res.data.orderId}});
						return;
					}
					else
					{
						this.$message({
							message: res.message,
							type: "warning"
						});
						return;
					}
										
				});
				
			},
			ReturnShoppingCart()
			{
				localStorage.setItem('cartIds',"");
				localStorage.setItem('payList',"");
				this.$router.push({name:'CarVue'})
			},
			showPopup(id){
				this.popupVisible = true;
				this.editInvoiceId=id;
			},
			closePopup(){
				this.popupVisible = false;
				this.GetMemberInfo();
			},
			showAddress(id){
				this.addressVisible = true;
				this.editId=id;
			},
			closeAddress(){
				this.addressVisible = false;
				this.getReceiveInfo();
			},
			getReceiveInfo() {
				this.receiveInfo=[];
				this.$scUtil.axiosPut(this, 'ReceiveApi/GetReceiveList', {
					pageIndex:0,
					pageSize:10,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						res.data.forEach(item => {
							if(item.is_default==1)
							{
									this.receiveId=item.id;
							}
						});
						this.receiveInfo = res.data;

						this.contactcount=res.totalcount;
					}
				
				});
			},
			DeleteContact(id){
					this.$confirm(this.$t('pages.confirmOrder.confirm_delete_receive'), this.$t('pages.confirmOrder.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('pages.confirmOrder.confirm_confirm'),
					        cancelButtonText: this.$t('pages.confirmOrder.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try 
						 {
				         	this.$scUtil.axiosPost(this, 'ReceiveApi/Delete', {
				         		id: id,
				         	}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getReceiveInfo();
				         			//console.log("为什么删除了不刷新数据");
									//console.log(JSON.stringify(this.shopCartList));
				         			return;
				         		}
				         
				         	});
				         } catch (error) {
				         	console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						console.log(action)
				        if (action == 'cancel'||cation=='close') {
							console.log("执行了吗")
				          this.getReceiveInfo();
				        }
				})
			},
			SetDefault(id,memberId){
					this.$confirm(this.$t('pages.confirmOrder.confirm_set_default'), this.$t('pages.confirmOrder.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('pages.confirmOrder.confirm_confirm'),
					        cancelButtonText: this.$t('pages.confirmOrder.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try 
						 {
				         	this.$scUtil.axiosPost(this, 'ReceiveApi/SetDefault', {
				         		id: id,
								memberId:memberId
				         	}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getReceiveInfo();
				         			console.log("为什么删除了不刷新数据");
									console.log(JSON.stringify(this.shopCartList));
				         			return;
				         		}
				         
				         	});
				         } catch (error) {
				         	console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						console.log(action)
				        if (action == 'cancel'||cation=='close') {
							console.log("执行了吗")
				          this.getReceiveInfo();
				        }
				})
			},
			GetMemberInfo()
			{
				this.memberInfo=[];
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						//console.log(JSON.stringify(this.memberInfo))
					}
				
				});
			}
		}
	}
</script>

<style scoped>
	.steps{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.pageArea{
		background-color: #ebecee;
	}

	.mainArea{
		display:flex;
		flex-direction: column;
		align-items: center;
	}

	.sortTitle{
		width: 1200px;
		height: 40px;
		line-height: 40px;
		font-size: 13px;
		color: #333333;
	}

	.stepTextLeft{
		text-align: left;
		font-size: 13px;
		color: #0380fe;
		margin-top:3px;
	}

	.stepTextMiddle{
		font-size: 13px;
		color: #0380fe;
		text-align: center;
		margin-top:3px;
	}

	.stepTextRight{
		font-size: 13px;
		text-align: right;
		color: #333333;
		margin-top:3px;
	}

	.cardArea{
		width: 1200px;
		background-color: #fff;
		padding: 14px;
		box-sizing: border-box;
		margin-bottom: 25px;
	}

	.cardTitle{
		display: flex;
		align-items: center;
	}

	.title{
		font-size: 17px;
		color: #000000;
		font-weight: bolder;
		margin-right: 20px;
	}

	.addressTitleBtn{
		font-size: 13px;
		color: #0380fe;
		cursor: pointer;
	}

	.addressAddArea{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 25px 0;
	}

	.addressIcon{
		margin-right: 18px;
	}

	.addressBtn{
		color: #0380fe;
		cursor: pointer;
	}

	.invoiceBtn{
		display: flex;
		align-items: center;
	}


	.invoiceBtn .orange{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #ff8d50;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

	.invoiceBtn .blue{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #0380fe;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

	.addInvoice{
		width: 719px;
		height: 48px;
		background: #f4f4f4;
		border-radius: 5px;
		color: #0380fe;
		font-size: 13px;
		padding-left: 16px;
		box-sizing: border-box;
		line-height: 48px;
		margin-top: 22px;
		cursor: pointer;
	}

	.payBtn{
		width: 101px;
		height: 32px;
		border: 1px solid #0380fe;
		color: #0380fe;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin-top: 20px;
		border-radius: 5px;
	}

	.payWay{
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333333;
		margin-top: 15px;
	}

	.payIcon{
		margin: 0 10px 0 13px;
	}

	.cardTitle{
		display: flex;
		justify-content: space-between;
		height: 64px;
	}

	.backCar{
		color: #0380fe;
		font-size: 14px;
	}

	.listTitle{
		font-size: 17px;
		color: #000;
	}

	.cardArea2{
		width: 1200px;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.cardArea2 .cardTitle{
		padding: 0 12px;
		box-sizing: border-box;
	}

	.cardArea2 table {
		width: 1200px;
		border-collapse: collapse;
	}

	.cardArea2 table thead{
		background: #f9f9f9;
		border: 1px solid #e2e2e2;
		border-left:none;
		border-right: none;
		font-size: 14px;
		color: #000;
		height: 46px;
	}

	.infoDetail{
		width: 128px;
		word-break: break-all;
	}

	.cardArea2 table tr{
		border-bottom: 1px solid #e2e2e2;
	}

	.cardArea2 table tr td{
		color: #000;
		font-size: 13px;
		min-width: 100px;
		padding: 20px 0;
	}

	.tdInner{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		color: #000000;
		margin: 0 auto;
	}

	.tdFlex{
		flex-direction: row;
	}

	.tdFlex img{
		width: 79px;
		height: 79px;
		border: 1px solid #e7e7e7;
		margin-right: 15px;
	}

	.parameterInfo{
		font-size: 13px;
		color: #000000;
		width: 193px;
		word-break: break-all;
	}

	.grayText{
		font-size: 13px;
		color: #888888;
	}

	.layouArea{
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	.layoutTitle{
		font-size: 14px;
		color:#000000;
		width: 125px;
		text-align: right;
	}

	.tabBtns{
		display: flex;
		align-items: center;
	}

	.tabBtn{
		height: 30px;
		line-height: 30px;
		padding: 0 17px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #cccccc;
		border-radius: 5px;
		position: relative;
		margin-right: 18px;
	}

	.tabBtn.active{
		border: 1px solid #0380fe;
	}

	.tabBtn img{
		position: absolute;
		bottom: 0px;
		right: 0px;
	}

	.inputText{
		width: 459px;
		height: 30px;
		border: 1px solid #cccccc;
		font-size: 14px;
		color: #000;
		padding-left: 15px;
	}


	.inputText:focus{
		outline: none;
	}

	.inputText::placeholder{
	  color: #888888;
	  font-size: 14px;
	}

	.updateTip{
		font-size: 12px;
		color: #888888;
		margin-top: 20px;
	}

	.downIcon{
		margin-left: 10px;
	}

	.settlement{
		display: flex;
		align-items: center;
	}

	.settlementTitle{
		flex: 1;
		text-align: right;
		font-size: 13px;
		color:#000000;
		line-height: 35px;
	}

	.settlementVal{
		width: 127px;
		text-align: right;
		font-size: 13px;
		color: #db050f;
		line-height: 35px;
		margin-right: 15px;
	}

	.settlementBtns{
		height: 92px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		border-top: 1px solid #e2e2e2;
	}

	.settlementText{
		font-size: 15px;
		color: #000000;
	}

	.settlementText span{
		font-size: 20px;
		color: #db050f;
		font-weight: bolder;
	}

	.settlementBtn{
		width: 142px;
		height: 44px;
		background: #0380fe;
		border-radius: 5px;
		color: #fff;
		font-size: 18px;
		font-weight: bolder;
		margin-left: 25px;
		text-align: center;
		line-height: 44px;
	}

	.updateArea{
		position: relative;
		width: 88px;
		height: 88px;
	}

	.updateArea img{
		position: absolute;
		top: 0;
		left: 0;
	}

	.updateArea input{
		display: none;
	}

	.uploadImgs{
		display: flex;
		flex-wrap: wrap;
	}

	.uploadImgs img{
		min-width: 88px;
		width: 88px;
		height: 88px;
		margin-right: 15px;
	}

	.addressli,.addressInfo{
		display: flex;
		align-items: center;
		font-size: 13px;
	}

	.addressli{
		margin-top: 10px;
	}

	.addressInfo{
		background: #f2f2f2;
		height: 32px;
		padding: 0 10px;
		box-sizing: border-box;
		color: #222;
		justify-content: space-between;
		flex: 1;
	}

	.userName{
		background-image: url(../assets/images/btnBg1.png);
		width: 108px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		margin-right: 10px;
	}

	.userName.active{
		background-image: url(../assets/images/btnBg.png);
	}

	.delText{
		color: #888888;
	}

	.addressTool{
		color: #0380fe;
		display: flex;
		align-items: center;
	}

	.initBtn{
		width: 42px;
		height: 19px;
		background-color: #0380fe;
		color: #fff;
		text-align: center;
		line-height: 19px;
		border-radius: 5px;
	}

	.addressLeft{
		display: flex;
		align-items: center;
	}

	.addrTel{
		margin-right: 15px;
	}

	.addressTool div{
		margin-left: 15px;
	}

	.invoiceDetail{
		width: 719px;
		background: #f4f4f4;
		font-size: 13px;
		color: #333333;
		padding: 10px;
		box-sizing: border-box;
		margin-top: 10px;
	}

	.invoiceDetail ul li{
		line-height: 25px;
		list-style: none;
	}

	.invoiceEditBtn{
		color: #0380fe;
		font-size: 13px;
		float: right;
		margin-right: 20px;
	}
	.moreAddress{
			margin-top: 10px;
			font-size: 12px;
			color: #666;
		}
	
		.arrowBottom{
			margin-left: 10px;
			transform: rotate(90deg);
		}
	
		.arrowTop{
			margin-left: 10px;
			transform: rotate(-90deg);
		}
</style>